import { useEffect, useState } from "react";
import api from "../utils/axios";


const Admin = () => {
  const [donations, setDonations] = useState([]);

  const fetchDonations = async () => {
    const res = await api.get("/admin/donations", {
      headers: {
        "x-admin-key": "igf_admin_2025",
      },
    });
    setDonations(res.data);
  };

  const verifyDonation = async (id) => {
    await api.post(
      `/admin/verify/${id}`,
      {},
      {
        headers: { "x-admin-key": "igf_admin_2025" },
      }
    );
    fetchDonations();
  };

  useEffect(() => {
    fetchDonations();
  }, []);

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">IGF Admin Panel</h1>

      <table className="w-full border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">Donor</th>
            <th className="p-2 border">Mobile</th>
            <th className="p-2 border">Amount</th>
            <th className="p-2 border">Status</th>
            <th className="p-2 border">Action</th>
          </tr>
        </thead>
        <tbody>
          {donations.map((d) => (
            <tr key={d._id}>
              <td className="border p-2">{d.donor?.name}</td>
              <td className="border p-2">{d.donor?.phone}</td>
              <td className="border p-2">₹{d.amount}</td>
              <td className="border p-2">
                {d.status === "verified" ? "✅ Verified" : "⏳ Pending"}
              </td>
              <td className="border p-2">
                {d.status === "pending" && (
                  <button
                    onClick={() => verifyDonation(d._id)}
                    className="bg-green-600 text-white px-3 py-1 rounded"
                  >
                    Verify
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Admin;
